"use client";

import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { cn } from "@repo/common/utils/cn";
import { useMobileSize } from "@repo/common/hooks/use-mobile-size";
const TooltipProvider = TooltipPrimitive.Provider;
const Tooltip = t0 => {
  const $ = _c(14);
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  const isMobile = useMobileSize();
  const [open, setOpen] = React.useState(false);
  if (isMobile) {
    let t1;
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = () => setOpen(true);
      t2 = {
        display: "inline-block"
      };
      $[3] = t1;
      $[4] = t2;
    } else {
      t1 = $[3];
      t2 = $[4];
    }
    let t3;
    if ($[5] !== children) {
      t3 = <span onClick={t1} style={t2}>{children}</span>;
      $[5] = children;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    let t4;
    if ($[7] !== open || $[8] !== props || $[9] !== t3) {
      t4 = <TooltipPrimitive.Root data-slot="tooltip" open={open} onOpenChange={setOpen} delayDuration={0} {...props}>{t3}</TooltipPrimitive.Root>;
      $[7] = open;
      $[8] = props;
      $[9] = t3;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    return t4;
  }
  let t1;
  if ($[11] !== children || $[12] !== props) {
    t1 = <TooltipPrimitive.Root data-slot="tooltip" delayDuration={200} {...props}>{children}</TooltipPrimitive.Root>;
    $[11] = children;
    $[12] = props;
    $[13] = t1;
  } else {
    t1 = $[13];
  }
  return t1;
};
const TooltipTrigger = t0 => {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("cursor-pointer touch-manipulation", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <TooltipPrimitive.Trigger data-slot="tooltip-trigger" className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
TooltipTrigger.displayName = TooltipPrimitive.Trigger.displayName;
const TooltipContent = t0 => {
  const $ = _c(10);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      sideOffset: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const sideOffset = t1 === undefined ? 4 : t1;
  let t2;
  if ($[4] !== className) {
    t2 = cn("z-50 overflow-hidden rounded-md border bg-background px-3 py-1.5 text-sm text-foreground-muted shadow-md", "animate-in fade-in-0 zoom-in-95", "data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95", "data-[side=bottom]:slide-in-from-top-2", "data-[side=left]:slide-in-from-right-2", "data-[side=right]:slide-in-from-left-2", "data-[side=top]:slide-in-from-bottom-2", className);
    $[4] = className;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== props || $[7] !== sideOffset || $[8] !== t2) {
    t3 = <TooltipPrimitive.Content data-slot="tooltip-content" sideOffset={sideOffset} className={t2} {...props} />;
    $[6] = props;
    $[7] = sideOffset;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
TooltipContent.displayName = TooltipPrimitive.Content.displayName;
export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };